import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    currentStatus:{},
    cs_error:'',
    cs_status:'idle',

    //clearReport
    clearReport:{},

    //current status
    currentStatusData:{},
    currentApiStatus:"idle",
    currentStatusError:"",
    currentStatusApiCall:0
};

export const fetchCurrentProgress = createAsyncThunk('dashboard/fetchCurrentProgress', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('Form/getDashboardCurrentProgress',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const clearReportData = createAsyncThunk('dashboard/clearReportData', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('form/clearUserData',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const fetchCurrentStatus = createAsyncThunk('dashboard/fetchCurrentStatus', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('form/getDashboardCurrentStatus',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});


const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}

const dashboardSlice = createSlice({
    name:'dashboard',
    initialState,
    reducers:{
        blankCurrentProgress:(state)=>{
            state.currentStatus = {};
        },
        blankClearReportData:(state)=>{
            state.clearReport = {};
        },
        blankCurrentStatus:(state)=>{
            state.currentApiStatus = "idle";
            state.currentStatusData = {};
            state.currentStatusError = "";
        },
        setCurrentStatusApiCall:(state,action)=>{
            state.currentStatusApiCall = action.payload;
        }
    },
    extraReducers:(builder) => {
        builder.addCase(fetchCurrentProgress.pending, (state)=>{
            state.cs_status = 'loading';
        })
        builder.addCase(fetchCurrentProgress.fulfilled,(state,action)=>{
            state.cs_status = 'succeeded';
            state.currentStatus = action.payload;
            state.cs_error = '';
        })
        builder.addCase(fetchCurrentProgress.rejected,(state,action)=>{
            state.cs_status = 'failed';
            state.currentStatus = {};
            state.cs_error = action.error.message;
        })

        builder.addCase(fetchCurrentStatus.pending, (state)=>{
            state.currentApiStatus = 'loading';
        })
        builder.addCase(fetchCurrentStatus.fulfilled,(state,action)=>{
            state.currentApiStatus = 'succeeded';
            state.currentStatusData = action.payload;
            state.currentStatusError = '';
        })
        builder.addCase(fetchCurrentStatus.rejected,(state,action)=>{
            state.currentApiStatus = 'failed';
            state.currentStatusData = {};
            state.currentStatusError = action.error.message;
        })

        builder.addCase(clearReportData.fulfilled,(state,action)=>{
            state.clearReport = action.payload;
        })
    }
})

export const {blankCurrentProgress,blankClearReportData,blankCurrentStatus,setCurrentStatusApiCall} = dashboardSlice.actions;

export default dashboardSlice.reducer;